import React from 'react'
import starInactive from '@assets/images/icons/star-inactive.svg'
import starActive from '@assets/images/icons/star-active.svg'

const FavoriteButton = ({ isFavorite, onToggle }) => {
  const starIcon = isFavorite ? starActive : starInactive
  
  return (
    <button
      className={`markets-table-favorite ${isFavorite ? 'markets-table-favorite--active' : ''}`}
      aria-label={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
      type="button"
      onClick={onToggle}
    >
      <img
        src={starIcon}
        alt={isFavorite ? 'Starred' : 'Not starred'}
        className="markets-table-favorite__icon"
      />
    </button>
  )
}

export default FavoriteButton

